import React from 'react'
import {GetMyOrderPreferencesQuery} from '@data/__generated__/types.main'

export const OrderPreferencesContext =
  React.createContext<GetMyOrderPreferencesQuery['preferences']>(null)

export default function useOrderPreferences() {
  const preferences = React.useContext(OrderPreferencesContext)

  return preferences
}
